// Constants
import { DISCLAIMER_TEXT } from './disclaimer.constants'

// Styles
import { DisclaimerText } from './disclaimer.styles'

export const Disclaimer = (): React.ReactElement => {
  return <DisclaimerText>{DISCLAIMER_TEXT}</DisclaimerText>
}
